import { render, staticRenderFns } from "./shopNotice.vue?vue&type=template&id=2461c24c&scoped=true"
import script from "./shopNotice.vue?vue&type=script&lang=js"
export * from "./shopNotice.vue?vue&type=script&lang=js"
import style0 from "./shopNotice.vue?vue&type=style&index=0&id=2461c24c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2461c24c",
  null
  
)

export default component.exports